import React, { useState, useEffect } from 'react'
import CloseIcon from '../../assets/CloseIcon'
import DotsIcon from '../../assets/DotsIcon'
import EditIcon from '../../assets/EditIcon'
import TrashIcon from '../../assets/TrashIcon'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import {
    getAllMFSHelper,
    addMFSHelper,
    updateMFSHelper,
    deleteMFSHelper
} from '../../helper/mfs-details-helper'
import { getAllBanksHelper } from '../../helper/bank-details-helper'

const MFS_FIELDS = {
    ID: 'id',
    MFS_NAME: 'mfs_name',
    MFS_ACCOUNT_NAME: 'mfs_account_name',
    ACCOUNT_NUMBER: 'account_number',
    PAYMENT_RECEIVER_BANK_ID: 'payment_receiver_bank_id',
    TRANSACTION_CHARGE: 'transaction_charge'
}

const MFSDetails = ({ onBackClick, onClose }) => {
    const [mfsList, setMfsList] = useState([])
    const [banks, setBanks] = useState([])
    const [open, setOpen] = useState(false)
    const [viewOpen, setViewOpen] = useState(false)
    const [mfsData, setMfsData] = useState({})
    const [selectedMFS, setSelectedMFS] = useState(null)
    const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [activeCardIndex, setActiveCardIndex] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        loadMFS()
        loadBanks()
    }, [])

    const loadMFS = () => {
        getAllMFSHelper()
            .then(res => {
                console.log('MFS loaded: ', res)
                setMfsList(res || [])
            })
            .catch(err => {
                console.log('Error loading MFS: ', err)
                setMfsList([])
            })
    }

    const loadBanks = () => {
        getAllBanksHelper()
            .then(res => {
                console.log('Banks loaded for dropdown: ', res)
                setBanks(res || [])
            })
            .catch(err => {
                console.log('Error loading banks: ', err)
                setBanks([])
            })
    }

    const handleDrawerToggle = () => {
        setOpen(!open)
        if (open) {
            resetForm()
        }
    }

    const handleViewDrawerToggle = () => {
        setViewOpen(!viewOpen)
        if (viewOpen) {
            setSelectedMFS(null)
        }
    }

    const handleMFSDetailUpdate = (key, value) => {
        setMfsData({
            ...mfsData,
            [key]: value
        })
    }

    const resetForm = () => {
        setMfsData({})
        setIsFieldErrorVisible(false)
        setIsEditMode(false)
    }

    const checkValidation = () => {
        return (
            mfsData[MFS_FIELDS.MFS_NAME] &&
            mfsData[MFS_FIELDS.MFS_ACCOUNT_NAME] &&
            mfsData[MFS_FIELDS.ACCOUNT_NUMBER]
        )
    }

    const handleSubmit = () => {
        if (!checkValidation()) {
            setIsFieldErrorVisible(true)
            return
        }

        setIsFieldErrorVisible(false)
        setIsLoading(true)

        if (isEditMode) {
            updateMFSHelper(mfsData)
                .then(res => {
                    console.log('MFS updated: ', res)
                    loadMFS()
                    resetForm()
                    handleDrawerToggle()
                })
                .catch(err => {
                    console.log('Error updating MFS: ', err)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        } else {
            addMFSHelper(mfsData)
                .then(res => {
                    console.log('MFS added: ', res)
                    loadMFS()
                    resetForm()
                    handleDrawerToggle()
                })
                .catch(err => {
                    console.log('Error adding MFS: ', err)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        }
    }

    const handleViewMFS = (mfs) => {
        setSelectedMFS(mfs)
        setActiveCardIndex(null)
        setViewOpen(true)
    }

    const handleEditMFS = (mfs) => {
        setMfsData(mfs)
        setIsEditMode(true)
        setActiveCardIndex(null)
        setOpen(true)
    }

    const handleDeleteMFS = (mfsId) => {
        deleteMFSHelper(mfsId)
            .then(res => {
                console.log('MFS deleted: ', res)
                loadMFS()
            })
            .catch(err => {
                console.log('Error deleting MFS: ', err)
            })
        setActiveCardIndex(null)
    }

    const toggleCardMenu = (index, e) => {
        e.stopPropagation()
        setActiveCardIndex(activeCardIndex === index ? null : index)
    }

    const getBankNameById = (bankId) => {
        const bank = banks.find(b => b.id === bankId)
        return bank ? bank.bank_name : '-'
    }

    return (
        <>
            <div className="pageBodyRightPanel">
                <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter webVisible mb-5">
                    <div className="pageBodyRightPanelHeading">MFS Details</div>
                    <div className="addProductBtn dFlex aiCenter">
                        <button
                            className="btn btnPrimary"
                            onClick={handleDrawerToggle}>
                            ADD
                        </button>
                        {onClose && (
                            <div
                                className="pointer ml-4"
                                onClick={() => onClose()}>
                                <CloseIcon />
                            </div>
                        )}
                    </div>
                </div>

                {mfsList.length === 0 ? (
                    <div className="pageBodyPanelWrap">
                        <div className="emptyState">
                            <p>No MFS details added yet. Click ADD to add your first MFS.</p>
                        </div>
                    </div>
                ) : (
                    <div className="bankListWrap">
                        <table className="bankTable">
                            <thead>
                                <tr>
                                    <th>MFS Name</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {mfsList.map((mfs, index) => (
                                    <tr
                                        key={mfs[MFS_FIELDS.ID] || index}
                                        className="bankRow"
                                        onClick={() => handleViewMFS(mfs)}>
                                        <td className="bankName">
                                            {mfs[MFS_FIELDS.MFS_NAME]}
                                        </td>
                                        <td className="bankActions">
                                            <div className="actionWrapper">
                                                <span
                                                    className="dotsIcon pointer"
                                                    onClick={(e) => toggleCardMenu(index, e)}>
                                                    <DotsIcon />
                                                </span>
                                                {activeCardIndex === index && (
                                                    <ul className="cardActionsWrapper show">
                                                        <li
                                                            className="actionItem"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleEditMFS(mfs)
                                                            }}>
                                                            <EditIcon /> Edit
                                                        </li>
                                                        <li
                                                            className="actionItem"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleDeleteMFS(mfs[MFS_FIELDS.ID])
                                                            }}>
                                                            <TrashIcon /> Delete
                                                        </li>
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Add/Edit MFS Drawer */}
                <SideDrawer
                    handleDrawerToggle={handleDrawerToggle}
                    open={open}
                    downloadButton={true}
                    downloadText={'SAVE'}
                    drawerHeading={isEditMode ? 'Edit MFS' : 'Add New MFS'}
                    handleClick={() => handleSubmit()}
                    isLoading={isLoading}>
                    <div className="wizardFieldset">
                        <form className="mt-5">
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="mfsName"
                                    placeholder="MFS Name"
                                    value={mfsData[MFS_FIELDS.MFS_NAME] || ''}
                                    onChange={e =>
                                        handleMFSDetailUpdate(
                                            MFS_FIELDS.MFS_NAME,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="mfsName">MFS Name</label>
                                {isFieldErrorVisible &&
                                    !mfsData[MFS_FIELDS.MFS_NAME] && (
                                        <div className="invalidFeedback">
                                            Please enter MFS Name.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="mfsAccountName"
                                    placeholder="MFS Account Name"
                                    value={mfsData[MFS_FIELDS.MFS_ACCOUNT_NAME] || ''}
                                    onChange={e =>
                                        handleMFSDetailUpdate(
                                            MFS_FIELDS.MFS_ACCOUNT_NAME,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="mfsAccountName">MFS Account Name</label>
                                {isFieldErrorVisible &&
                                    !mfsData[MFS_FIELDS.MFS_ACCOUNT_NAME] && (
                                        <div className="invalidFeedback">
                                            Please enter MFS Account Name.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="accountNumber"
                                    placeholder="Account Number"
                                    value={mfsData[MFS_FIELDS.ACCOUNT_NUMBER] || ''}
                                    onChange={e =>
                                        handleMFSDetailUpdate(
                                            MFS_FIELDS.ACCOUNT_NUMBER,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="accountNumber">Account Number</label>
                                {isFieldErrorVisible &&
                                    !mfsData[MFS_FIELDS.ACCOUNT_NUMBER] && (
                                        <div className="invalidFeedback">
                                            Please enter Account Number.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <select
                                    className="formControl"
                                    id="paymentReceiverBank"
                                    value={mfsData[MFS_FIELDS.PAYMENT_RECEIVER_BANK_ID] || ''}
                                    onChange={e =>
                                        handleMFSDetailUpdate(
                                            MFS_FIELDS.PAYMENT_RECEIVER_BANK_ID,
                                            e.target.value
                                        )
                                    }
                                >
                                    <option value="">Select Bank</option>
                                    {banks.map((bank) => (
                                        <option key={bank.id} value={bank.id}>
                                            {bank.bank_name}
                                        </option>
                                    ))}
                                </select>
                                <label htmlFor="paymentReceiverBank">Payment Receiver Bank</label>
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="number"
                                    className="formControl"
                                    id="transactionCharge"
                                    placeholder="Transaction Charge (%)"
                                    value={mfsData[MFS_FIELDS.TRANSACTION_CHARGE] || ''}
                                    onChange={e =>
                                        handleMFSDetailUpdate(
                                            MFS_FIELDS.TRANSACTION_CHARGE,
                                            e.target.value
                                        )
                                    }
                                    min="0"
                                    step="0.01"
                                />
                                <label htmlFor="transactionCharge">Transaction Charge (%)</label>
                            </div>
                        </form>
                    </div>
                </SideDrawer>

                {/* View MFS Drawer */}
                <SideDrawer
                    handleDrawerToggle={handleViewDrawerToggle}
                    open={viewOpen}
                    drawerHeading="MFS Details">
                    {selectedMFS && (
                        <div className="wizardFieldset">
                            <div className="bankViewDetails mt-5">
                                <div className="viewItem">
                                    <div className="viewLabel">MFS Name</div>
                                    <div className="viewValue">
                                        {selectedMFS[MFS_FIELDS.MFS_NAME] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">MFS Account Name</div>
                                    <div className="viewValue">
                                        {selectedMFS[MFS_FIELDS.MFS_ACCOUNT_NAME] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Account Number</div>
                                    <div className="viewValue">
                                        {selectedMFS[MFS_FIELDS.ACCOUNT_NUMBER] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Payment Receiver Bank</div>
                                    <div className="viewValue">
                                        {getBankNameById(selectedMFS[MFS_FIELDS.PAYMENT_RECEIVER_BANK_ID])}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Transaction Charge</div>
                                    <div className="viewValue">
                                        {selectedMFS[MFS_FIELDS.TRANSACTION_CHARGE] ? `${selectedMFS[MFS_FIELDS.TRANSACTION_CHARGE]}%` : '-'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </SideDrawer>
            </div>
        </>
    )
}

export default MFSDetails
